import { Spinner } from "reactstrap";
import { styled } from "styled-components";

const LoadingContainer = styled.div`
    padding: 30px;
    border-radius: 5px;
    background-color: #f5f5f5;
    margin-bottom: 10px;
    height: 100%;
    width: 100%;
    overflow: auto; 
    position: absolute;
    @media (max-width: 768px) {
        height: 80vh;
    }
    display: flex;
`

const SpinnerContainer = styled.div`
    margin: auto;
`

const LoadingPage = () => {
    return (
        <LoadingContainer>
            <SpinnerContainer>
                <Spinner
                    color="primary"
                    type="grow"
                >
                    Loading...
                </Spinner>
                <Spinner
                    color="secondary"
                    type="grow"
                >
                    Loading...
                </Spinner>
                <Spinner
                    color="success"
                    type="grow"
                >
                    Loading...
                </Spinner>
                <Spinner
                    color="danger"
                    type="grow"
                >
                    Loading...
                </Spinner>
                <Spinner
                    color="warning"
                    type="grow"
                >
                    Loading...
                </Spinner>
                <Spinner
                    color="info"
                    type="grow"
                >
                    Loading...
                </Spinner>
                <Spinner
                    color="light"
                    type="grow"
                >
                    Loading...
                </Spinner>
                <Spinner
                    color="dark"
                    type="grow"
                >
                    Loading...
                </Spinner>
            </SpinnerContainer>
        </LoadingContainer>
    )
}

export default LoadingPage;